// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9711) return "static/chunks/9711-30027197a5682647.js";
	if (chunkId === 2175) return "static/chunks/2175-954ca548636baf7b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4917":"606002888b741569","6506":"5df6fedbe332b8f2"}[chunkId] + ".js";
};